var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrw-price-tag",style:({
  'display': 'flex',
  'column-gap': _vm.spacing + 'px',
})},[(_vm.prefix)?_c('span',{staticClass:"price-tag-prefix"},[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_c('span',{staticClass:"price-tag-value"},[_vm._v(_vm._s(_vm._f("formatMoney")(_vm.value)))]),_c('span',{staticClass:"price-tag-currency"},[_vm._v(_vm._s(_vm.currency.symbol))])])
}
var staticRenderFns = []

export { render, staticRenderFns }